export default __webpack_public_path__ + "static/media/burger.7b24c079.png";